import {api} from '../../api/common.js'
import gql from 'graphql-tag'

const data = {
 // Login
 // Live URL https://api.tefl.org/employee/login/
  login: ({ ...args }) => new Promise((resolve, reject) => {
    api.post(process.env.SERVER_URL+'/auth/login/', args.data)
      .then(function (response) {
        console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  tutorLogin: ({ ...args }) => new Promise((resolve, reject) => {
    api.post(process.env.SERVER_URL+'/auth/tutor-login/', args.data)
      .then(function (response) {
        console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  loginAs: ({ ...args }) => new Promise((resolve, reject) => {
    api.post(process.env.SERVER_URL+'/auth/login-as/', args.data)
      .then(function (response) {
        console.log(response)
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  // Login
  getLoggedInUserProfile: (role, id) => new Promise((resolve, reject) => {
    api.get(process.env.SERVER_URL + '/auth/public-data?role=' + role + '&id=' + id)
    .then(function (response) {
      console.log('public data', response)
      resolve(response)
    })
    .catch((error) => {
      reject(error)
    })
  }),
  getAdminUsers: () => new Promise((resolve, reject) => {
    api.get(process.env.SERVER_URL + '/auth/adminusers')
  .then(function (response) {
    resolve(response)
  })
  .catch((error) => {
    reject(error)
  })
  }),
  getUserRole: () => new Promise((resolve, reject) => {
    api.get('/users/meta')
  .then(function (response) {
    console.log('get user role', response.data.data['employee-role'])
    resolve(response.data.data['employee-role'])
  })
  .catch((error) => {
    reject(error)
  })
  })
}
export default data



// WEBPACK FOOTER //
// ./src/components/Login/api.js